module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.investorPage) ? _c('div', {
    staticClass: "investor"
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('input', {
    ref: "loadPreviewButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadAboutPreview
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header-wrapper",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.pageChanged
    },
    model: {
      value: (_vm.pageObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "isHidden", $$v)
      },
      expression: "pageObject.isHidden"
    }
  }, [_vm._v("Скрыть страницу")])], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.pageChanged
    },
    model: {
      value: (_vm.pageObject.isInvestorPage),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "isInvestorPage", $$v)
      },
      expression: "pageObject.isInvestorPage"
    }
  }, [_vm._v("Страница инвестора (иначе эмитента)")])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Загрузить фото\n        ")])]), _vm._v(" "), _c('b-field', {
    staticClass: "p-option"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": _vm.handleUpdatePage
    },
    model: {
      value: (_vm.pageObject.title),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "title", $$v)
      },
      expression: "pageObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "p-option"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdatePage
    },
    model: {
      value: (_vm.pageObject.description),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "description", $$v)
      },
      expression: "pageObject.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Описание")]), _vm._v(" "), _c('div', {
    staticClass: "investment-description page-header-wrapper",
    style: (_vm.descriptionStyle)
  }, [_c('div', {
    staticClass: "description-wrapper translucent-wrapper"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadAboutPreview
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить превью для видео\n        ")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Текст"
    },
    model: {
      value: (_vm.pageObject.aboutTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "aboutTitle", $$v)
      },
      expression: "pageObject.aboutTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    staticClass: "p-option color-black",
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'aboutDescriptionEditor'
    },
    model: {
      value: (_vm.aboutDescription),
      callback: function($$v) {
        _vm.aboutDescription = $$v
      },
      expression: "aboutDescription"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Ссылка на видео"
    },
    model: {
      value: (_vm.pageObject.aboutVideoUrl),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "aboutVideoUrl", $$v)
      },
      expression: "pageObject.aboutVideoUrl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Для кого")]), _vm._v(" "), _c('div', {
    staticClass: "gray-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.pageObject.potentialusersTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "potentialusersTitle", $$v)
      },
      expression: "pageObject.potentialusersTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "advantages"
  }, [_vm._l((_vm.pageObject.potentialUsers), function(user) {
    return _c('PotentialUser', {
      key: user.id,
      attrs: {
        "potentialUser": user
      }
    })
  }), _vm._v(" "), (_vm.pageObject.potentialUsers) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddPotentialUser
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить блок\n          ")])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Особенности")]), _vm._v(" "), _c('div', {
    staticClass: "gray-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.pageObject.advantagesTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "advantagesTitle", $$v)
      },
      expression: "pageObject.advantagesTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "advantages"
  }, [_vm._l((_vm.pageObject.advantages), function(advantage) {
    return _c('AdvantageOrReason', {
      key: advantage.id,
      attrs: {
        "instance": advantage,
        "deleteFunc": _vm.deleteInvestorPageAdvantage,
        "updateFunc": _vm.updateInvestorPageAdvantage,
        "useEditor": false
      }
    })
  }), _vm._v(" "), (_vm.pageObject.advantages && _vm.pageObject.advantages.length < 6) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddAdvantage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить блок\n          ")])]) : _vm._e()], 2)], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Тарифные планы")]), _vm._v(" "), _c('div', {
    staticClass: "gray-wrapper rates-block"
  }, [_c('b-field', {
    staticClass: "p-option"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок блока тарифных планов"
    },
    on: {
      "change": _vm.handleUpdatePage
    },
    model: {
      value: (_vm.pageObject.ratesTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "ratesTitle", $$v)
      },
      expression: "pageObject.ratesTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('Editor', {
    staticClass: "p-option color-black",
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": 'ratesDescriptionEditor'
    },
    model: {
      value: (_vm.ratesDescription),
      callback: function($$v) {
        _vm.ratesDescription = $$v
      },
      expression: "ratesDescription"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticClass: "p-option"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок файла"
    },
    on: {
      "change": _vm.handleUpdatePage
    },
    model: {
      value: (_vm.pageObject.ratesFileTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "ratesFileTitle", $$v)
      },
      expression: "pageObject.ratesFileTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('el-select', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Выбрать документ сравнения тарифов",
      "clearable": ""
    },
    on: {
      "change": _vm.changeDocument
    },
    model: {
      value: (_vm.selectedDocument),
      callback: function($$v) {
        _vm.selectedDocument = $$v
      },
      expression: "selectedDocument"
    }
  }, _vm._l((_vm.newDocumentsData), function(document) {
    return _c('el-option', {
      key: [document.path, document.resource_id].join('###'),
      attrs: {
        "label": ("" + (document.display_name)),
        "value": [document.path, document.resource_id].join('###')
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.pageChanged
    },
    model: {
      value: (_vm.pageObject.ratesIsConsultation),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "ratesIsConsultation", $$v)
      },
      expression: "pageObject.ratesIsConsultation"
    }
  }, [_vm._v("\n        Показать кнопку консультации\n      ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Причины выбрать")]), _vm._v(" "), _c('div', {
    staticClass: "gray-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.pageObject.reasonsTitle),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "reasonsTitle", $$v)
      },
      expression: "pageObject.reasonsTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "advantages"
  }, [_vm._l((_vm.pageObject.reasons), function(reason) {
    return _c('AdvantageOrReason', {
      key: reason.id,
      attrs: {
        "instance": reason,
        "deleteFunc": _vm.deleteInvestorPageReason,
        "updateFunc": _vm.updateInvestorPageReason,
        "useEditor": true
      }
    })
  }), _vm._v(" "), (_vm.pageObject.reasons && _vm.pageObject.reasons.length < 5) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddReason
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить блок\n        ")])]) : _vm._e()], 2)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "promo-wrapper is-flex"
  }, [_c('el-select', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Выбрать акцию",
      "clearable": ""
    },
    on: {
      "change": _vm.changePromo
    },
    model: {
      value: (_vm.selectedPromo),
      callback: function($$v) {
        _vm.selectedPromo = $$v
      },
      expression: "selectedPromo"
    }
  }, _vm._l((_vm.servicePromos), function(promo) {
    return _c('el-option', {
      key: promo.id,
      attrs: {
        "label": promo.title,
        "value": promo.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveInvestorPage()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ') + "\n    ")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Акция, соответствующая услуге")]), _vm._v(" "), _c('span', [_vm._v("Чтобы добавить акцию перейдите в меню \"Акции\"")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6541a84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BondedLoan/investorComponents/Investor.vue
// module id = 988
// module chunks = 0